import * as React from 'react';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import { system_notification } from 'src/store/slice/system';
import AxiosSingletonLoader from 'src/component/AxiosSingletonLoader,';
import store from 'src/storeWire';
import System from "../../../helper/system";

const AddToBom = (props) => {
    const [_check_p] = useCheckAuthPermissions();
    const { single_product, isBomPLP, addToBOMSwapModeByBomDetailID } = props;
    const bomId = System.getParams().bomId
    const bomDetailId = System.getParams().bomDetailId
    const getDisplayStatus = () => {
        if (single_product) {
            if (isBomPLP !== undefined && isBomPLP === 'yes') {
                return true;
            }
        }
        return false;
    };
    const addToBomOrSwap = () => {
        store.dispatch(system_notification({
            name: 'AddedToBomPopup',
            data: {
                single_product: single_product,
                swap_mode: addToBOMSwapModeByBomDetailID,
                bomId,
                bomDetailId
            },
        }));
    };

    const openContactUsPopup = () => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: {restrict:true},
        }));
    };
    return (
        <>

            {
                (getDisplayStatus() && single_product.ERPPartNumber !== undefined && single_product.ERPPartNumber !== null && single_product.ERPPartNumber !== '' && single_product.ERPPartNumber !== ' ' &&
                    <>
                        <AxiosSingletonLoader
                            customAxiosButtonIndicatorRunTimeLoader={true}
                            slugKey={['BOM_SWAP_PART_NUMBER_API_CALL', 'PRODUCT_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'BOM_OPERATION_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'CART_API_CALL']}>
                            <button onClick={() => {
                                addToBomOrSwap()
                            }} className="bs5 btn btn-primary w-100">Add To Bom
                            </button>
                        </AxiosSingletonLoader>

                        {single_product && !single_product.ObsoleteFlag &&
                            <div className="mt-1">
                                <a href={void (0)} className="text-blue" onClick={() => {
                                    _check_p('PD_CLICK_TO_QUOTE').status === false ? openContactUsPopup() :
                                    store.dispatch(system_notification({
                                        name: 'QuotePopup',
                                        data: {
                                            single_product: single_product,
                                            addFrom: 'PLP'
                                        },
                                    }));
                                }}>Click To Quote</a>
                            </div>
                        }
                    </>
                )
            }
        </>

    );
};

export default AddToBom;